import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/index'
import Login from '@/views/login/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: '',
    component: Home,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "homeindex" */ '@/views/home/index.vue'),
      },
      {
        path: '/achievements',
        name: 'Achievement',
        component: () => import(/* webpackChunkName: "achievementList" */ '@/views/list/index.vue'),
        meta: {
          title: '成果列表',
        },
      },
      {
        path: '/dynamic',
        name: 'DynamicList',
        component: () => import(/* webpackChunkName: 'dynamicList'*/ '@/views/list/index.vue'),
        meta: {
          title: '动态列表',
        },
      },
      {
        path: '/expert',
        name: 'Expert',
        // component: () => import(/* webpackChunkName: 'expert'*/ '@/views/list/expertList.vue'),
        component: () => import(/* webpackChunkName: 'expert'*/ '@/views/list/index.vue'),
        meta: {
          title: '专家列表',
        },
      },
      {
        path: '/organization',
        name: 'Organization',
        component: () => import(/* webpackChunkName: 'organization'*/ '@/views/list/orgList.vue'),
        meta: {
          title: '机构列表',
        },
      },
      {
        path: '/achievements/detail',
        name: 'AchDetail',
        component: () => import(/*webpackChunName:'achDetail'*/ '@/views/detail/achievementDetail.vue'),
        meta: {
          title: '成果详情',
          bread: [{ title: '成果列表', path: '/achievements' }],
        },
      },
      {
        path: '/dynamic/detail',
        name: 'DynamicDetail',
        component: () => import(/*webpackChunName:'dynamicDetail'*/ '@/views/detail/achievementDetail.vue'),
        meta: {
          title: '动态详情',
          bread: [{ title: '动态列表', path: '/dynamic' }],
        },
      },
      {
        path: '/expert/detail',
        name: 'PersonDetail',
        component: () => import(/*webpackChunName:'personDetail'*/ '@/views/detail/personDetail.vue'),
        meta: {
          title: '专家详情',
          bread: [{ title: '专家列表', path: '/expert' }],
        },
      },
      {
        path: '/organization/detail',
        name: 'OrgDetail',
        component: () => import(/*webpackChunName:'OrgDetail'*/ '@/views/detail/orgDetail.vue'),
        meta: {
          title: '机构详情',
          bread: [{ title: '机构列表', path: '/organization' }],
        },
      },
      {
        path: '/search',
        name: 'SearchList',
        component: () => import(/*webpackChunName:'searchList'*/ '@/views/list/index.vue'),
        meta: {
          title: '列表',
        },
      },
      {
        path: '/topics',
        name: 'TopicsPage',
        component: () => import(/*webpackChunName:'TopicsPage'*/ '@/views/topic/index.vue'),
        meta: {
          title: '领域',
        },
      },
      {
        path: '/topics/politics',
        name: 'TopicsPolitics',
        component: () => import(/*webpackChunName:'TopicsPolitics'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '政治专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/economics',
        name: 'Topicseconomics',
        component: () => import(/*webpackChunName:'Topicseconomics'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '经济专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/technology',
        name: 'Topicstechnology',
        component: () => import(/*webpackChunName:'Topicstechnology'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '科技专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/teach',
        name: 'Topicsculture',
        component: () => import(/*webpackChunName:'Topicsculture'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '教育专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/social',
        name: 'Topicssocial',
        component: () => import(/*webpackChunName:'Topicssocial'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '社会专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/military',
        name: 'Topicsmilitary',
        component: () => import(/*webpackChunName:'Topicsmilitary'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '军事专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/environment',
        name: 'Topicsenvironment',
        component: () => import(/*webpackChunName:'Topicsenvironment'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '环境专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/energy',
        name: 'Topicslaw',
        component: () => import(/*webpackChunName:'Topicslaw'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '能源专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/health',
        name: 'Topicslaw',
        component: () => import(/*webpackChunName:'Topicslaw'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '健康专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/agriculture',
        name: 'Topicslaw',
        component: () => import(/*webpackChunName:'Topicslaw'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '农业专题详情',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/topics/other',
        name: 'Topicsother',
        component: () => import(/*webpackChunName:'Topicsother'*/ '@/views/detail/specialDetail.vue'),
        meta: {
          title: '其他专题',
          bread: [{ title: '领域', path: '/topics' }],
        },
      },
      {
        path: '/myCenter',
        name: 'myCenter',
        component: () => import(/*webpackChunName:'myCenter'*/ '@/views/mycenter/index.vue'),
        meta: {
          title: '个人中心',
        },
      },
      {
        path:'/data_statistics',
        name:'statics',
        component: () => import(/*webpackChunkName: 'statics' */ '@/views/statics/index.vue'),
        meta: {
          title: '统计页',
        },
      }
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/common/toPay',
    name: '',
    component: () => import('@/views/common/to'),
  },
  {
    path: '/weixin/pay',
    name: '微信支付',
    component: () => import('@/views/weixin/pay'),
    hidden: true,
  },
  {
    path: '/weixin/auth',
    name: '微信登录',
    component: () => import('@/views/weixin/auth'),
    hidden: true,
  },
  {
    path: '/vip_agreement',
    name: 'vip_agreement',
    component: () => import(/*webpackChunName:'vip_agreement'*/ '@/views/agreenMent/agreenMent.vue'),
    meta: {
      title: '会员协议',
    },
  },
  {
    path: '/user_agreement',
    name: 'user_agreement',
    component: () => import(/*webpackChunName:'user_agreement'*/ '@/views/agreenMent/agreenMent.vue'),
    meta: {
      title: '用户协议',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router

//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

import { Message } from 'element-ui'

import { LIST_MODULECODE_MAP } from '@/utils/staticData'

router.beforeEach(async (to, from, next) => {
  let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {}
  let right = 1
  let { userName = ''} = userInfo

  if (to.path === '/myCenter' && (userName === '' || userName === 'guest')) {
    next('/')
    return
  }

  /* 直接跳转---需要权限的页面 
  注：新开页跳转在main.js公用方法中设置
  */
  let needRightPageMap = {
    ...LIST_MODULECODE_MAP,
  }
  //页面完成跳转后才会从已存在页面请求到权限信息，所以新开标签页如果是需要权限才能访问的页面，在路由判断是无法获取到session里的信息的，目前先判断，如果是新开页先把right设置为1，后续再调整
  if (Object.keys(userInfo).length) {
    if (needRightPageMap[to.path]) {
      right = userInfo.moduleRightInfo?.[needRightPageMap[to.path]]?.listRight
    }
  } else {
    right = 1
  }
  // debugger
  // console.log(right, to.path, needRightPageMap);
  //如果用户未登录访问用户中心页面重定向至首页

  if (right === 1) {
    next()
  } else {
    {
      Message({
        message: '无页面访问权限',
        type: 'warning',
      })
    }
    next('/')
  }
})
